import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducer';
import {isDev} from '../helpers/env';

export default function configureStore(initialState) {
  const middlewares = [thunkMiddleware];
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middlewares)
  );

  if (isDev() && module.hot) {
    module.hot.accept('./reducer', () => {
      /* eslint-disable global-require */
      store.replaceReducer(require('./reducer').default);
      /* eslint-enable global-require */
    });
  }

  return store;
}
